import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import "./tailwind.css";
import App from "./App";
import ScrollToTop from "./resources/scrollTop";
import { axHistory, HistoryRouter } from "./resources/axHistory";
import { GlobalContextProvider } from "./context/GlobalContext";

ReactDOM.render(
  <React.StrictMode>
    <HistoryRouter history={axHistory}>
      <GlobalContextProvider>
        <ScrollToTop />
        <App />
      </GlobalContextProvider>
    </HistoryRouter>
  </React.StrictMode>,
  document.getElementById("root")
);
